import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'antm-callback',
  standalone: true,
  imports: [MatProgressSpinner, MatButton, NgOptimizedImage],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  readonly hasError = signal(false);

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has('code')) {
      await this.router.navigate(['/home']);
      return;
    }

    const success = await this.authService.handleCallback();

    if (success) {
      await this.router.navigate(['/home']);
    } else {
      this.hasError.set(true);
    }
  }

  retry(): void {
    this.authService.login();
  }
}
